import { takeEvery } from 'redux-saga/effects';

import * as searchPageActionTypes from 'store/modules/searchPage/actionTypes';
import { setLocation } from './utils';

export default function* listenSearch() {
  yield takeEvery(searchPageActionTypes.SET_LOCATION, setLocation);
}
